import { GeographicAddress } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconFieldComponent } from '../icon-field';

import { DeepPartial } from '@iss/wo-common/types';
import { GeographicAddressPipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-address',
  standalone: true,
  templateUrl: './address.component.html',
  styleUrls: [ './address.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IconFieldComponent,
    GeographicAddressPipe,
  ],
})
export class AddressComponent {
  @Input() public address?: DeepPartial<GeographicAddress> | null;
  @Input() public icon: 'building-community' | 'pin' = 'building-community';
}
